import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';

export const fetchSummerplay = async ({ franchiseId }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/newSummerplay/${franchiseId}/groups`,
    );
    console.log('response', response);

    return response.data.summerplay_groups || [];
  } catch (error) {
    toast.error(
      'Wystąpił problem pobierając grupy półkolonii. Odśwież aplikację.',
    );

    return [];
  }
};

// [
//   {
//     id: 4,
//     summerplay_type_id: 1,
//     workshop_location_id: 1,
//     physical_address: "physical address",
//     location_title: "location title",
//     latitude: "52.38136900",
//     longitude: "16.74524510",
//     description: "some desc",
//     all_week_price: "100 zł",
//     age: "6-7 lat",
//     places_total: 10,
//     signups: 2,
//     start_date: "2021-11-10T00:00:00+01:00",
//     end_date: "2021-11-20T00:00:00+01:00",
//     is_signup_allowed: 1,
//     only_all_week: true,
//   },
//   {
//     id: 5,
//     summerplay_type_id: 2,
//     workshop_location_id: 1,
//     physical_address: "physical address",
//     location_title: "location title",
//     latitude: "52.38136900",
//     longitude: "16.74524510",
//     description: "some desc - can pick days",
//     all_week_price: "200 zł",
//     age: "16-17 lat",
//     places_total: 6,
//     signups: 0,
//     start_date: "2021-11-20T00:00:00+01:00",
//     end_date: "2021-11-30T00:00:00+01:00",
//     is_signup_allowed: 1,
//     only_all_week: false,
//   },
//   {
//     id: 6,
//     summerplay_type_id: 1,
//     workshop_location_id: 2,
//     physical_address: "physical address",
//     location_title: "location title",
//     latitude: "52.38136900",
//     longitude: "16.84524510",
//     description: "some desc - can pick days",
//     all_week_price: "400 zł",
//     age: "0-1 lat",
//     places_total: 2,
//     signups: 0,
//     start_date: "2021-11-20T00:00:00+01:00",
//     end_date: "2021-11-30T00:00:00+01:00",
//     is_signup_allowed: 1,
//     only_all_week: false,
//   },
// ];
